<template>
  <div>
    <div style="text-align: right;">
      <span
        style="float: left; margin-top: 5px;"
        class="ant-descriptions-title"
      >
        My Info
      </span>
    </div>

    <a-descriptions :column="1">
      <a-descriptions-item label="Employee code / Mã nhân viên">
        {{ employee.code }}
      </a-descriptions-item>
      <a-descriptions-item label="Employee / Tên nhân viên">
        {{ employee.fullname }}
      </a-descriptions-item>
      <a-descriptions-item label="Gender / Giới tính">
        <span v-if="employee.gender === 'NONE'">Khác </span>
        <span v-else-if="employee.gender === 'MALE'">Nam </span>
        <span v-else-if="employee.gender === 'FEMALE'">Nữ</span>
      </a-descriptions-item>
      <a-descriptions-item label="Birthday / Ngày sinh">
        {{ employee.birthday | formatDate }}
      </a-descriptions-item>
      <a-descriptions-item label="Email">
        {{ employee.email }}
      </a-descriptions-item>
      <a-descriptions-item label="Account / Người dùng">
        {{ employee.user && employee.user.fullname }}
      </a-descriptions-item>
      <a-descriptions-item label="Department / Phòng ban">
        <span
          v-if="
            employee.department && employee.department.status === 'DEACTIVE'
          "
        >
          <del> {{ employee.department.name }} </del>
        </span>
        <span
          v-else-if="
            employee.department && employee.department.status === 'ACTIVE'
          "
        >
          {{ employee.department.name }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Position / Chức vụ">
        <span
          v-if="employee.position && employee.position.status === 'DEACTIVE'"
        >
          <del> {{ employee.position.name }} </del>
        </span>
        <span
          v-else-if="employee.position && employee.position.status === 'ACTIVE'"
        >
          {{ employee.position.name }}
        </span>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    employee: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
};
</script>
